<template>
  <form action="#" class="pre-game" @submit.prevent="start">
    <div class="form">
      <h2>Image selection</h2>

      <drop-zone class="form-field" field-id="file-uploader" accept=".jpg,.jpeg,.png,.gif,.svg" @change="handleFileChange">
        <template slot="label">Select one of your images</template>
        <template slot="dropping">(or drop one here)</template>
      </drop-zone>
      <div class="form-field">
        <label for="image-url">Or give an URL</label>
        <div class="input-line">
          <input id="image-url" v-model="selectedImage" type="text" placeholder="https://xyz.com/image.png">
          <button type="button" class="btn--start" @click="handleSelectChange">Load</button>
        </div>
      </div>
      <div class="form-field">
        <label for="image-selector">Or use one of ours (from Wikimedia)</label>
        <select id="image-selector" v-model="selectedImage" @change="handleSelectChange">
          <option disabled selected value>Choose a picture</option>
          <option v-for="img in images" :key="img.src" :value="img.url">{{ img.title }}</option>
        </select>
      </div>
      <div class="form-field">
        <label for="tiles-x">Amount of tiles (horizontal)</label>
        <div class="input-line">
          <input id="tiles-x" v-model="tilesX" type="number">
          <button type="button" class="btn--icon-like" @click="tilesX --">-</button>
          <button type="button" class="btn--icon-like" @click="tilesX ++">+</button>
        </div>
      </div>
    </div>

    <div class="preview-area">
      <h2>Preview</h2>
      <div v-if="error" class="info info--error">{{ error }}</div>
      <div v-else-if="loading" class="info info--loading">Loading...</div>
      <img v-else-if="image && loaded" :src="image.src" alt="Preview" class="preview">
      <p v-else class="info">Select an image first</p>
    </div>

    <div class="form-actions">
      <button id="start-button" type="submit" :disabled="!image" class="btn--start btn--large btn--block">
        Start
      </button>
    </div>
  </form>
</template>

<script>
import images from '../data/jigsaw_images'
import DropZone from './DropZone'

export default {
  name: 'JigsawForm',
  components: { DropZone },
  data () {
    return {
      images,
      selectedImage: '',
      loading: false,
      image: null,
      loaded: false,
      error: null,
      tilesX: 10,
    }
  },
  methods: {
    handleSelectChange () {
      if (this.badFileExtension(this.selectedImage)) return
      this.image = new Image()
      this.image.src = this.selectedImage
      this.attachLoader()
    },
    handleFileChange (files) {
      const file = files[0]

      if (this.badFileExtension(file.name)) return

      this.image = new Image()
      this.image.src = window.URL.createObjectURL(file)
      this.attachLoader()
    },
    attachLoader () {
      this.loaded = false
      this.loading = true
      this.image.addEventListener('load', () => {
        this.loaded = true
        this.loading = false
      })
    },
    badFileExtension (path) {
      this.error = null
      const test = /\.(gif|jpg|jpeg|png|svg)$/i.test(path)
      if (!test) {
        this.error = `You should use an image. Allowed types are gif, jpg, png and svg`
        return true
      }
      return false
    },
    start () {
      this.$emit('start', { image: this.image, tilesX: this.tilesX })
    },
  },
}
</script>
